import styled, { createGlobalStyle } from 'styled-components'

export const GlobalCardMb16 = createGlobalStyle`
  /* ===== 去掉 Drawer关闭按钮背景色 ===== */
  .ant-drawer-header{
    background: var(--white-100) !important;
  }
    
  .mb16 {
    width: var(--percent-100);
    background-color: var(--white-100);
    background-clip: border-box;
    border: 1px solid var(--black-5);
    border-radius: var(--border-radius-16);
    margin-bottom: var(--gap-24);

    .ant-card-body {
      padding: var(--gap-12);
    }

    .ant-card-head-title {
      font-size: var(--font-size-14);
      margin: -4px;
      overflow: visible !important;
      > *:first-child {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
      }
    }

    /* 折叠箭头过渡动画 */
    .ant-card-extra {
      span {
        display: inline-block;
      }
      
      .anticon {
        transition: var(--transition-normal);
        display: inline-block;
      }
    }

    /* 折叠内容过渡动画 */
    .ant-card-body {
      overflow: hidden;
      transition: var(--transition-normal);
      
      > * {
        animation: fadeIn 0.25s ease-in-out;
      }
    }

    /* 操作列内容居中 */
    .ant-table-cell {
      &[data-operation="true"] {
        text-align: center !important;
        vertical-align: middle !important;
        
        > * {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100%;
        }
      }
    }

    /* 去除最后一个Card的下边距 */
    &:last-child {
      margin-bottom: 0;
    }
  }

  /* 淡入动画 */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
    
  /* 让 Modal 永远在最上层 */
  .top-most-success-modal {
    z-index: 9999 !important;
  }
  .top-most-success-modal .ant-modal-mask {
    z-index: 9999 !important;
  }
  .top-most-success-modal .ant-modal-wrap {
    z-index: 9999 !important;
  }
`